var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path3, _path4, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _path5, _path6, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _rect, _path7, _rect2, _path8, _rect3, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 144,
    viewBox: "0 0 288 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1541 60.6153C11.1541 70.1741 18.9031 91.7692 28.4618 91.7692C38.0206 91.7692 45.7695 70.1741 45.7695 60.6153C45.7695 51.0565 38.0206 43.3076 28.4618 43.3076C18.9031 43.3076 11.1541 51.0565 11.1541 60.6153Z",
    fill: "#004092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2303 60.6153C40.2303 70.1741 47.9792 91.7692 57.538 91.7692C67.0968 91.7692 74.8457 70.1741 74.8457 60.6153C74.8457 51.0565 67.0968 43.3076 57.538 43.3076C47.9792 43.3076 40.2303 51.0565 40.2303 60.6153Z",
    fill: "#539EFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.92308,
    cy: 6.92308,
    r: 6.92308,
    transform: "matrix(-1 0 0 1 35.3857 53.6914)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.92308,
    cy: 6.92308,
    r: 6.92308,
    transform: "matrix(-1 0 0 1 64.4629 53.6914)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4616,
    cy: 97.3073,
    r: 2.76923,
    fill: "#004092"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.154,
    cy: 97.3073,
    r: 2.76923,
    fill: "#004092"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.8464,
    cy: 97.3073,
    r: 2.76923,
    fill: "#004092"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5388,
    cy: 97.3073,
    r: 2.76923,
    fill: "#004092"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.154 60.6153C107.154 70.1741 114.903 91.7692 124.462 91.7692C134.021 91.7692 141.77 70.1741 141.77 60.6153C141.77 51.0565 134.021 43.3076 124.462 43.3076C114.903 43.3076 107.154 51.0565 107.154 60.6153Z",
    fill: "#004092"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.23 60.6153C136.23 70.1741 143.979 91.7692 153.538 91.7692C163.097 91.7692 170.846 70.1741 170.846 60.6153C170.846 51.0565 163.097 43.3076 153.538 43.3076C143.979 43.3076 136.23 51.0565 136.23 60.6153Z",
    fill: "#539EFF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.92308,
    cy: 6.92308,
    r: 6.92308,
    transform: "matrix(-1 0 0 1 131.386 53.6914)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.92308,
    cy: 6.92308,
    r: 6.92308,
    transform: "matrix(-1 0 0 1 160.463 53.6914)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.462,
    cy: 97.3073,
    r: 2.76923,
    fill: "#004092"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.154,
    cy: 97.3073,
    r: 2.76923,
    fill: "#004092"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.846,
    cy: 97.3073,
    r: 2.76923,
    fill: "#004092"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.539,
    cy: 97.3073,
    r: 2.76923,
    fill: "#004092"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.077 58.3081C196.077 69.9911 205.548 96.3851 217.231 96.3851C228.914 96.3851 238.385 69.9911 238.385 58.3081C238.385 46.6252 228.914 37.1543 217.231 37.1543C205.548 37.1543 196.077 46.6252 196.077 58.3081Z",
    fill: "#004092"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M231.615 58.3081C231.615 69.9911 241.086 96.3851 252.769 96.3851C264.452 96.3851 273.923 69.9911 273.923 58.3081C273.923 46.6252 264.452 37.1543 252.769 37.1543C241.086 37.1543 231.615 46.6252 231.615 58.3081Z",
    fill: "#539EFF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.46154,
    cy: 8.46154,
    r: 8.46154,
    transform: "matrix(-1 0 0 1 225.694 49.8457)",
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.46154,
    cy: 8.46154,
    r: 8.46154,
    transform: "matrix(-1 0 0 1 261.232 49.8457)",
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.23,
    cy: 103.154,
    r: 3.38462,
    fill: "#004092"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.076,
    cy: 103.154,
    r: 3.38462,
    fill: "#004092"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.923,
    cy: 103.154,
    r: 3.38462,
    fill: "#004092"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.768,
    cy: 103.154,
    r: 3.38462,
    fill: "#004092"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 101L167.5 105L174.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 101L71.5 105L78.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 273,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 124,
    r: 2,
    fill: "white"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 29,
    r: 2,
    fill: "white"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 124.5,
    r: 1.5,
    fill: "white"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 14.5,
    r: 1.5,
    fill: "white"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 136.5,
    r: 1.5,
    fill: "white"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 123.5,
    r: 1.5,
    fill: "white"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 37.5,
    r: 1.5,
    fill: "white"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.5,
    cy: 35.5,
    r: 1.5,
    fill: "white"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 12.5L196 27.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M265.5 7L258.5 20.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M241 128L244.5 141.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceDistance);
export default __webpack_public_path__ + "static/media/persistence-distance.9dd95833a9cb93eaf49aedb51c0fc0f0.svg";
export { ForwardRef as ReactComponent };